import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, FormControl, FormControlLabel, FormGroup, Radio, RadioGroup, Typography } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { Ari } from '~/assets/icons';
import { MessageBubble } from '../Message';
import { Message } from '../types';
import { container, containerDefault, containerMessage, messageAfter } from '../UserConfirmation/styles';

interface Props {
  questionComponent?: Message['questionComponent'];
  Component?: Message['Component'];
  userName?: string;
  onMethodSelected?: (method: number) => void; // 2 = Email, 1 = SMS
  /** CORE-1025: cadastro sem telefone — SMS desabilitado e e-mail já marcado */
  smsDisabled?: boolean;
}

const SMS = 1;
const EMAIL = 2;

const DELIVERY_OPTIONS = [
  {
    id: 'sms',
    label: 'SMS',
    value: SMS,
    description: 'Receber código por SMS'
  },
  {
    id: 'email',
    label: 'E-mail',
    value: EMAIL,
    description: 'Receber código por E-mail'
  }
];

export const CodeDeliveryMethod = ({ userName, onMethodSelected, smsDisabled = false }: Props) => {
  const [selectedMethod, setSelectedMethod] = useState<number | null>(smsDisabled ? EMAIL : null);

  const handleMethodSelection = (event: ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value);
    setSelectedMethod(value);
  };

  const handleSendCode = () => {
    if (selectedMethod && onMethodSelected) {
      onMethodSelected(selectedMethod);
    }
  };

  return (
    <Box sx={containerDefault}>
      {/* Mensagem do bot */}
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Ari />
        <MessageBubble
          content={
            <Typography sx={{ color: 'white', fontWeight: 'bold' }}>
              {userName?.split(' ')[0] || 'Usuário'}, vamos enviar um código de verificação para confirmar seu cadastro,
              como você prefere receber?
            </Typography>
          }
        />
      </Box>

      {/* Opções de entrega do código */}
      <Box sx={container}>
        <Box sx={() => containerMessage()}>
          <FormGroup>
            <FormControl>
              <RadioGroup
                aria-labelledby="radio-button-code-delivery-method"
                value={selectedMethod || ''}
                onChange={handleMethodSelection}
              >
                {DELIVERY_OPTIONS.map(({ value, label }) => (
                  <FormControlLabel
                    key={value}
                    value={value}
                    label={label}
                    disabled={smsDisabled && value === SMS}
                    control={
                      <Radio
                        inputProps={{ 'aria-label': label }}
                        checkedIcon={<CheckCircleIcon color="success" />}
                        sx={{ color: 'white' }}
                      />
                    }
                    sx={{ color: 'white', '& .MuiFormControlLabel-label.Mui-disabled': { color: 'grey.500' } }}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </FormGroup>
          {smsDisabled && (
            <Typography variant="caption" sx={{ color: 'grey.400', display: 'block', mt: 0.5 }}>
              Seu cadastro não tem celular cadastrado, por isso o código será enviado por e-mail.
            </Typography>
          )}
          <Box sx={messageAfter} />
        </Box>
      </Box>

      {/* Botão para enviar código */}
      {selectedMethod && (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
          <LoadingButton
            size="large"
            variant="contained"
            color="primary"
            onClick={handleSendCode}
            sx={{
              backgroundColor: '#A547FF',
              '&:hover': {
                backgroundColor: '#8A3CD9'
              }
            }}
          >
            Enviar código
          </LoadingButton>
        </Box>
      )}
    </Box>
  );
};
